import {
  createTheme,
  CssBaseline,
  ThemeProvider as MuiThemeProvider
} from "@material-ui/core"
import orange from "@material-ui/core/colors/orange"
import deepOrange from "@material-ui/core/colors/deepOrange"

// dark mode
// https://medium.com/heuristics/react-dark-mode-switch-in-material-ui-dashboard-82fcf1cded66
const darkState = false
const palletType = darkState ? "dark" : "light"
const mainPrimaryColor = darkState ? orange[500] : "#A00020"
const mainSecondaryColor = darkState ? deepOrange[900] : "#E9E9E9"

export const theme = createTheme({
  typography: {
    fontFamily: ["Roboto", "sans-serif"].join(","),
    button: {
      textTransform: "none"
    }
  },
  palette: {
    type: palletType,
    primary: {
      main: mainPrimaryColor
    },
    secondary: {
      main: mainSecondaryColor
    }
  },
  overrides: {
    // @ts-expect-error MuiDropzoneArea does not exist in type Overrides
    MuiDropzoneArea: {
      root: {
        minHeight: "100%"
      },
      text: {
        fontSize: "80%",
        fontWeight: "normal",
        color: "lightgray"
      }
    }
  }
})

const ThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}

export default ThemeProvider
